// libraries
import { RecentDeals, type RecentDealsProps } from '@makemydeal/dr-activities-recent-deals';

const RecentDealsContainer = ({ variant }: RecentDealsProps) => {
    return <RecentDeals variant={variant} />;
};

export default RecentDealsContainer;
